export const FETCH_MERCHANT_INFO = '[MERCHANT]FETCH_MERCHANT_INFO';
export const FETCH_MERCHANT_INFO_FAILED = '[MERCHANT]FETCH_MERCHANT_INFO_FAILED';
export const FETCH_MERCHANT_INFO_SUCCESS = '[MERCHANT]FETCH_MERCHANT_INFO_SUCCESS';

export const UPDATE_MERCHANT = `[MERCHANT]UPDATE_MERCHANT`;

export const FETCH_OTHER_MERCHANTS = `[MERCHANTS]FETCH_OTHER_MERCHANTS`;
